// extracted by mini-css-extract-plugin
export default {"fileRendererViewport":"RichDiff-module__fileRendererViewport--EBwd1","fileRendererIframe":"RichDiff-module__fileRendererIframe--svTsY"};